import { useTranslation } from '../../context/translationContext';
import { ObjectFromEnum } from '../../utils/functions/data.functions';
import Button from '../button/Button';

interface Props {
  tabs: ObjectFromEnum[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  children?: JSX.Element[];
}
/**
 *
 * @param tabs - enum of tabs
 * @param activeTab - currently selected tab
 * @param setActiveTab - sets tab active
 * @param children - content of tab, every child has to be in div with key value
 * @returns
 */
export const TabsComponent = ({ tabs, activeTab, setActiveTab, children }: Props) => {
  const { t } = useTranslation();
  const tabBaseClass = `inline-block py-3 px-2 border-b-2 rounded-t-lg hover:text-white hover:bg-blue-500`;
  const activeClass = `bg-blue-500 text-white`;

  return (
    <>
      {/* Tabs header */}
      <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <div className="text-sm font-medium text-center border-b border-gray-200">
          <ul className="flex flex-wrap -mb-px">
            {tabs.map((tab: ObjectFromEnum, index: number) => {
              return (
                <li key={index} className="mr-2">
                  <Button
                    title={t(tab.name)}
                    cleanClass
                    onClick={() => setActiveTab(tab.name)}
                    className={`${tabBaseClass} ${activeTab === tab.name ? activeClass : null}`}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      {/* Tabs content */}
      {children && children.filter((c: JSX.Element) => c.key === activeTab)}
    </>
  );
};
